import React, { useState, useEffect } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import Modal from "react-bootstrap/Modal";
import { GET_Instrucation_QB } from "../../gql/queries";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { Bookmark_QB } from "../../gql/mutation";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { trackEvent } from "../../../src/utils/moengageUserSetup";
export default function QbAllSolution() {
    const navigate = useNavigate();
    let location = useLocation();
    const [selectData, setData] = useState(JSON.parse(location.state));
    const [filter, applyFilter] = useState(false);
    const [apply, setapply] = useState([]);
    const [all, setAll] = useState(false);
    const [attempted, setAttempted] = useState(true);
    const [unattempted, setUnattempted] = useState(true);
    const [apiData, setApiData] = useState([])
    const [correct, setCorrect] = useState(true);
    const [incorrect, setIncorrect] = useState(true);

    const showfilter = () => applyFilter(true);
    const hideFilter = () => applyFilter(false);
    let { id, name } = useParams()

    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: GET_Instrucation_QB,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'qbInformation' // Query name,

        ],
    });
    const query1 = useQuery(GET_Instrucation_QB, {
        variables: {
            "_id": id,
        },
    });
    // console.log(apiData)
    // console.log(all,"all")
    let allData = []
    // trackEvent("ViewedWebPage", {
    //     url: window.location.href,
    //     timestamp: Date.now(),
    //   });
    const applyfilt = () => {
        query1.data && query1.data.qb.questions.map((obj, i) => {
            query1.data && query1.data.qb.progress.questions.map((obj1, index) => {
                if (attempted && obj1.questionId.toString() === (obj._id).toString()) {
                    allData.push(obj)
                }
                if (correct && obj1.questionId.toString() === (obj._id).toString() && obj.answer.includes(obj1.userAnswer)) {
                    // obj.corrected=true
                    allData.push(obj)
                }
                if (unattempted && obj1.questionId.toString() === (obj._id).toString() && obj1.userAnswer === '') {
                    // obj.skipped=true
                    allData.push(obj)
                }
                if (incorrect && obj1.questionId.toString() === (obj._id).toString() && !obj.answer.includes(obj1.userAnswer) && obj1.userAnswer !== '') {
                    // obj.incorrected=true
                    allData.push(obj)
                }
            })
        })
        let a = Array.from(new Set(allData.map((item) => item)))
        setapply(a)
        // if(count==4){
        //     setAll(true)
        // }
        hideFilter()
    }
    useEffect(() => {
        setApiData(query1.data)

        if (selectData !== null) {
            setAll(false)
            if (selectData == 'skip') {
                setAttempted(false)
                setUnattempted(true)
                setCorrect(false)
                setIncorrect(false)
                applyfilt()
            }
            else if (selectData == 'attempt') {
                setAttempted(true)
                setUnattempted(false)
                setCorrect(false)
                setIncorrect(false)
                applyfilt()
            }
            else if (selectData == 'correct') {
                setAttempted(false)
                setUnattempted(false)
                setCorrect(true)
                setIncorrect(false)
                applyfilt()
            }
            else if (selectData == 'incorrect') {
                setAttempted(false)
                setUnattempted(false)
                setCorrect(false)
                setIncorrect(true)
                applyfilt()
            }
        }
        else {
            setAll(true)
        }
    }, [apiData])
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error.graphQLErrors)
    }

    const Reset = () => {
        setAll(true)
        setAttempted(true)
        setUnattempted(true)
        setCorrect(true)
        setIncorrect(true)
    }



    const checkedbox = (e) => {
        setAll(e.target.checked)
        if (e.target.checked === false) {
            setAttempted(false)
            setUnattempted(false)
            setCorrect(false)
            setIncorrect(false)
        }
        else {
            setAttempted(true)
            setUnattempted(true)
            setCorrect(true)
            setIncorrect(true)
        }
    }
    const attemptCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setAttempted(e.target.checked)

    }
    const incorrectCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setIncorrect(e.target.checked)

    }
    const correctCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)

        }
        setCorrect(e.target.checked)
    }
    const unattemptedCheckedbox = (e) => {
        if (e.target.checked === false) {
            setAll(false)
        }
        setUnattempted(e.target.checked)
    }
    let count = 0
    if (all !== true) {
        if (attempted === true) {
            count = count + 1
        }
        if (unattempted === true) {
            count = count + 1
        }
        if (correct === true) {
            count = count + 1
        }
        if (incorrect === true) {
            count = count + 1

        }

    }
    if (all === true) {
        count = count + 4
    }

    return (
        <>
            {all !== true &&
                <div className="main_wrapper">
                    <div className="breadcrumbs">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a >Home</a></li>
                            <li className="breadcrumb-item"><a >QBank</a></li>
                            {/* <li className="breadcrumb-item"><a >Anatomy</a></li>
                    <li className="breadcrumb-item"><a >Head, Neck and Face</a></li>
                    <li className="breadcrumb-item"><a >Carnial Nerve Nuclei and Columns</a></li> */}
                            <li className="breadcrumb-item active"><a >View Solutions</a></li>
                        </ul>
                    </div>
                    <section className="videoLayer_wrapper allSolution_wrapper section_side_padding">
                        <div className='row'>
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="subjects_wrapper">
                                    <div className="setting_ttl_wrapper d-flex align-items-baseline">
                                        <figure className="sett_back_arrow">
                                            <Link to={`/qblayer/qbperformance/${id}/${name}`}>
                                                <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                            </Link>
                                        </figure>
                                        <div className="sett_ttl">
                                            <h5>Result Analysis</h5>
                                            <p>{query1.data ? query1.data?.qb?.title : ''}<span>QBank</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="recommended_video_wrapper">
                                    <div className="questions_listing">
                                        <div className="listing_hedr d-flex align-items-center">
                                            <div className="ques_list_ttl">
                                                <h6>Questions<span>({all ? query1.data.qb.questions.length : apply.length})</span></h6>
                                            </div>
                                            <div className="filter_ttl">
                                                <span onClick={showfilter}>
                                                    <img src={Icons.Filter} alt="filter" className="img-fluid" /> Apply Filter
                                                </span>
                                            </div>
                                        </div>
                                        <div className="applied_filter">
                                            <h6>filters applied</h6>
                                            <div className="applied_selected">
                                                <ul type="none" className="d-flex align0-items-center flex-wrap">
                                                    <li>
                                                        <div className="selected_filter d-flex align-items-center">
                                                            <p>Status<span>({count})</span></p>
                                                            <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                        </div>
                                                    </li>
                                                    {/* <li>
                                                    <div className="selected_filter d-flex align-items-center">
                                                        <p>Status<span>(9)</span></p>
                                                        <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="selected_filter d-flex align-items-center">
                                                        <p>Status<span>(9)</span></p>
                                                        <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="selected_filter d-flex align-items-center">
                                                        <p>Status<span>(9)</span></p>
                                                        <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                    </div>
                                                </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="solution_questions">
                                            <ul type="none" className="d-flex align-items-center flex-wrap">
                                                {
                                                    apply.map((d, i) => (
                                                        <li>
                                                            <Link to={`/qblayer/qball/${id}/${name}/${i}`} state={JSON.stringify(apply)}>
                                                                <div className="solution_body d-flex align-items-center">
                                                                    <figure className="ques_img">Q{i + 1}</figure>
                                                                    <div className="ques_body_content">
                                                                        <div className="ques_ttl_wrapper d-flex">
                                                                            <div className="question_ttl">
                                                                                <h6>{d?.question?.questionText}</h6>
                                                                            </div>
                                                                            {/* {
                                                                            query1.data && query1.data.qb.progress == null &&
                                                                            <span className="ques_bookmark" onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                                            </span>
                                                                        }
                                                                        {
                                                                            query1.data && query1.data.qb.progress != null && !query1.data.qb.progress.bookmarkedQids.includes(d._id) &&
                                                                            <span className="ques_bookmark" onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                                            </span>
                                                                        }
                                                                        {
                                                                            query1.data.qb.progress != null && query1.data.qb.progress.bookmarkedQids.includes(d._id) &&
                                                                            <span className="ques_bookmark" onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": false } })}>
                                                                                <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                                                            </span>
                                                                        } */}
                                                                            {/* <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div> */}
                                                                        </div>
                                                                        <div className="course_name d-flex">
                                                                            <div className="course_ttl">
                                                                                <p>{d.subjectDetail?.subjectName}</p>
                                                                            </div>
                                                                            <div className="course_arrow">
                                                                                <img src={Icons?.TestArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))
                                                }
                                                {/* <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
            {all === true &&
                <div className="main_wrapper">
                    <div className="breadcrumbs">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/">QBank</a></li>
                            {/* <li className="breadcrumb-item"><a href="/">Anatomy</a></li>
                    <li className="breadcrumb-item"><a href="/">Head, Neck and Face</a></li>
                    <li className="breadcrumb-item"><a href="/">Carnial Nerve Nuclei and Columns</a></li> */}
                            <li className="breadcrumb-item active"><a href="/">View Solutions</a></li>
                        </ul>
                    </div>
                    <section className="videoLayer_wrapper allSolution_wrapper section_side_padding">
                        <div className='row'>
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="subjects_wrapper">
                                    <div className="setting_ttl_wrapper d-flex align-items-baseline">
                                        <figure className="sett_back_arrow">
                                            <Link to={`/qblayer/qbperformance/${id}/${name}`}>
                                                <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                            </Link>
                                        </figure>
                                        <div className="sett_ttl">
                                            <h5>Result Analysis</h5>
                                            <p>{query1?.data ? query1.data.qb.title : ''}<span>QBank</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="recommended_video_wrapper">
                                    <div className="questions_listing">
                                        <div className="listing_hedr d-flex align-items-center">
                                            <div className="ques_list_ttl">
                                                <h6>Questions<span>({query1?.data && query1?.data?.qb?.questions.length})</span></h6>
                                            </div>
                                            <div className="filter_ttl">
                                                <span onClick={showfilter}>
                                                    <img src={Icons.Filter} alt="filter" className="img-fluid" /> Apply Filter
                                                </span>
                                            </div>
                                        </div>
                                        <div className="applied_filter">
                                            <h6>filters applied</h6>
                                            <div className="applied_selected">
                                                <ul type="none" className="d-flex align0-items-center flex-wrap">
                                                    <li>
                                                        <div className="selected_filter d-flex align-items-center">
                                                            <p>Status<span>({count})</span></p>
                                                            <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                        </div>
                                                    </li>
                                                    {/* <li>
                                                    <div className="selected_filter d-flex align-items-center">
                                                        <p>Status<span>(9)</span></p>
                                                        <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="selected_filter d-flex align-items-center">
                                                        <p>Status<span>(9)</span></p>
                                                        <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="selected_filter d-flex align-items-center">
                                                        <p>Status<span>(9)</span></p>
                                                        <img src={Icons.CloseItem} alt="" className="img-fluid" />
                                                    </div>
                                                </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="solution_questions">
                                            <ul type="none" className="d-flex align-items-center flex-wrap">
                                                {
                                                    query1.data && query1.data.qb.questions.map((d, i) => (
                                                        <li>
                                                            <Link to={`/qblayer/qball/${id}/${name}/${i}`} state={JSON.stringify(query1.data.qb.questions)}>
                                                                <div className="solution_body d-flex align-items-center">
                                                                    <figure className="ques_img">Q{i + 1}</figure>
                                                                    <div className="ques_body_content">
                                                                        <div className="ques_ttl_wrapper d-flex">
                                                                            <div className="question_ttl">
                                                                                <h6>{d.question.questionText}</h6>
                                                                            </div>
                                                                            {/* {
                                                                            query1.data && query1.data.qb.progress == null &&
                                                                            <span className="ques_bookmark" onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                                            </span>
                                                                        }
                                                                        {
                                                                            query1.data && query1.data.qb.progress != null && !query1.data.qb.progress.bookmarkedQids.includes(d._id) &&
                                                                            <span className="ques_bookmark" onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": true } })}>
                                                                                <img src={Icons.Bookmark} alt="share" className="img-fluid" />
                                                                            </span>
                                                                        }
                                                                        {
                                                                            query1.data.qb.progress != null && query1.data.qb.progress.bookmarkedQids.includes(d._id) &&
                                                                            <span className="ques_bookmark" onClick={() => getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: d._id, subjectId: query1.data.qb.subject, courseName: query1.data.qb.course[0], "status": false } })}>
                                                                                <img src={Icons.unBookmark} alt="share" className="img-fluid" />
                                                                            </span>
                                                                        } */}
                                                                            {/* <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div> */}
                                                                        </div>
                                                                        <div className="course_name d-flex">
                                                                            <div className="course_ttl">
                                                                                <p>{d?.subjectDetail?.subjectName}</p>
                                                                            </div>
                                                                            <div className="course_arrow">
                                                                                <img src={Icons.TestArrow} alt="" className="img-fluid" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    ))
                                                }
                                                {/* <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="solution_body d-flex align-items-center">
                                                <figure className="ques_img">Q13</figure>
                                                <div className="ques_body_content">
                                                    <div className="ques_ttl_wrapper d-flex">
                                                        <div className="question_ttl">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="ques_bookmark">
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                    <div className="course_name d-flex">
                                                        <div className="course_ttl">
                                                            <p>Pathology</p>
                                                        </div>
                                                        <div className="course_arrow">
                                                            <img src={Icons.TestArrow} alt="" className="img-fluid"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            }
            <Modal
                show={filter}
                onHide={hideFilter}
                backdrop="static"
                className="detail_modal apply_filter"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Filter <span><img src={Icons.Reload} alt="" className="img-fluid" onClick={Reset} />Reset Filter</span></h4>
                        {/* <span className="cross_icon">
                        <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideFilter}/>
                    </span> */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="filter_status_wrapper">
                        <div className="filter_body">
                            <div className="status_ttl">
                                <h6>Status<span>({count})</span></h6>
                            </div>
                            <div className="status_checkboxes">
                                <div class="custom-control custom-checkbox all_checkbox">
                                    <input type="checkbox" className="custom-control-input" id="all" checked={all} name="example1" onClick={(e) => checkedbox(e)} />
                                    <label className="custom-control-label" for="all">All</label>
                                </div>
                                <div className="filter_checkbox d-flex align-items-center flex-wrap">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="attempt" checked={attempted} onClick={(e) => attemptCheckedbox(e)} name="example1" />
                                        <label className="custom-control-label" for="attempt">Attempted</label>
                                        <span></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="correct" checked={correct} onClick={(e) => correctCheckedbox(e)} name="example1" />
                                        <label className="custom-control-label" for="correct">Correct</label>
                                        <span className="correct"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="incorrect" checked={incorrect} onClick={(e) => incorrectCheckedbox(e)} name="example1" />
                                        <label className="custom-control-label" for="incorrect">Incorrect</label>
                                        <span className="incorrect"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="skip" checked={unattempted} onClick={(e) => unattemptedCheckedbox(e)} name="example1" />
                                        <label className="custom-control-label" for="skip">Skipped</label>
                                        <span className="skip"></span>
                                    </div>
                                    {/* <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="guess" checked={true} name="example1" />
                                        <label className="custom-control-label" for="guess">Guessed</label>
                                        <span className="guess"></span>
                                    </div>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" id="review" checked={true} name="example1" />
                                        <label className="custom-control-label" for="review">Reviewed</label>
                                        <span className="review"></span>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={hideFilter}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={applyfilt} >Apply</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}
